import FileUpload from 'legacy/libs/components/file-upload'
import createReactClass from 'create-react-class'
import { GetText } from 'lib/gettext'

import s from './styles/gis-region.module.scss'

export default createReactClass({
  displayName: 'MapFileUpload',

  render() {
    return (
      <div className={s.upload__file}>
        <label htmlFor="inputFile">
          <GetText>
            Upload any sort of image file illustrating the map you would like to
            use. You can:
          </GetText>
          <br />

          <ul className="mb-4 list-disc pl-6 text-sm">
            <li>
              <GetText>Take a screenshot of a map you want to use</GetText>
            </li>

            <li>
              <GetText>
                Take a picture with your phone of a map in a book
              </GetText>
            </li>

            <li>
              <GetText>
                Draw a map on a piece of paper yourself and then take a picture
                of it
              </GetText>
            </li>
          </ul>
        </label>

        <FileUpload id="inputFile" {...this.props} />
      </div>
    )
  },
})
